import { mainSiteUrl } from "@/mocks/categories";

export default function CtaSection() {
  return (
    <section className="relative w-full overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20minimalist%20editorial%20photography%20of%20a%20beautifully%20styled%20fashion%20flat%20lay%20with%20sneakers%20folded%20clothing%20tote%20bag%20and%20accessories%20on%20clean%20warm%20cream%20sand%20surface%20bright%20soft%20natural%20daylight%20airy%20atmosphere%20modern%20lifestyle%20aesthetic%20neutral%20earth%20tones%20organic%20wide%20composition&width=1600&height=700&seq=mulebuy-cta-bg-2026x2&orientation=landscape"
          alt="Mulebuy spreadsheet CTA"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      {/* Content - Triangular composition */}
      <div className="relative z-10 w-full px-6 md:px-16 py-20 md:py-28">
        <div className="relative min-h-[320px] md:min-h-[380px]">
          {/* Top Left: Title */}
          <div className="absolute top-0 left-0 md:top-8 md:left-4">
            <h2 className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-white lowercase tracking-tight">
              explore mulebuy
              <br />
              spreadsheet
            </h2>
          </div>

          {/* Bottom Left: CTA Button */}
          <div className="absolute bottom-0 left-0 md:bottom-8 md:left-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-6 py-3.5 md:px-7 md:py-4 rounded-full bg-white text-foreground-950 font-medium text-sm md:text-base hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
            >
              buy it now
              <span className="w-6 h-6 flex items-center justify-center rounded-full bg-foreground-950">
                <i className="ri-arrow-right-line text-white text-xs"></i>
              </span>
            </a>
          </div>

          {/* Bottom Right: Description */}
          <div className="absolute bottom-0 right-0 md:bottom-8 md:right-4 max-w-xs">
            <p className="text-white/85 text-sm md:text-base leading-relaxed">
              Access the most updated product spreadsheet database.
              Start browsing trending items across all 14 categories today.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}